import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Service Worker Registration with Auto-Update
const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    console.log('[App] Service Worker not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('[App] SW registered:', registration.scope);

    // Check for updates periodically (every 60 seconds)
    setInterval(() => {
      registration.update();
      console.log('[App] Checking for SW updates...');
    }, 60 * 1000);

    // Handle waiting service worker (new version available)
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      console.log('[App] New SW installing...');
      
      newWorker?.addEventListener('statechange', () => {
        console.log('[App] SW state:', newWorker.state);
      });
    });

  } catch (error) {
    console.log('[App] SW registration failed:', error);
  }
};

// Listen for controller change (new SW activated) - auto reload
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  console.log('[App] New SW activated, reloading...');
  window.location.reload();
});

// Listen for messages from Service Worker
navigator.serviceWorker?.addEventListener('message', (event) => {
  if (event.data?.type === 'SW_UPDATED') {
    console.log('[App] SW updated to version:', event.data.version);
  }
});

// Register service worker when page loads
window.addEventListener('load', registerServiceWorker);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
